import React from 'react'
import {KTIcon} from '../../../../_metronic/helpers'
import {Link} from 'react-router-dom'

const Terms = () => {
  return (
    <div className='text-center'>
      <div className='mb-10'>
        <KTIcon iconName='setting-4' className='fs-2hx' />
        <h1 className='fs-2hx'>Under Development</h1>
      </div>
      <Link to='/auth/login'>
        <button
          type='button'
          id='kt_login_signup_form_cancel_button'
          className='btn btn-lg btn-light-primary w-100 mb-5'
        >
          Back To Login
        </button>
      </Link>
    </div>
  )
}

export default Terms
